// Cómo va el cierre de la venta, al pie del paso 09. Lo comparten las dos pistas y las dos pantallas
// del contado: el cierre corre igual en todas, y su fallo tiene que verse igual.
import { Button } from '@/kit';

export function SaleStatus({
    saleRef,
    error,
    retrying,
    onRetry,
    pendingLabel = 'Registrando la venta…',
}: {
    /** Referencia legible de la venta (VTA-xxx). */
    saleRef?: string;
    error: string | null;
    retrying: boolean;
    /** Sin él no se ofrece reintentar: el error no se arregla repitiendo la llamada. */
    onRetry?: () => void;
    /** Qué decir mientras no hay venta ni error — en crédito el cierre espera a la activación. */
    pendingLabel?: string;
}) {
    if (saleRef) {
        return <span className="text-[12.5px] text-success">Venta registrada · {saleRef}</span>;
    }
    if (error) {
        return (
            <span className="flex flex-wrap items-center gap-2 text-[12px] text-destructive">
                {error}
                {onRetry && (
                    <Button variant="outline" size="sm" isLoading={retrying} onClick={onRetry}>
                        Reintentar
                    </Button>
                )}
            </span>
        );
    }
    return <span className="text-[12.5px] text-muted-foreground">{pendingLabel}</span>;
}
